/**
 * Colored badge for document status
 * Per specification:
 * - Approved → Green
 * - Under Review → Blue
 * - Draft → Gray
 * - Superseded → Red
 */
export function DocumentStatusBadge({ status }) {
  const statusConfig = {
    approved: {
      label: "Approved",
      bgColor: "#d1fae5",
      textColor: "#065f46",
      borderColor: "#a7f3d0",
    },
    under_review: {
      label: "Under Review",
      bgColor: "#dbeafe",
      textColor: "#0c4a6e",
      borderColor: "#bfdbfe",
    },
    draft: {
      label: "Draft",
      bgColor: "#f3f4f6",
      textColor: "#374151",
      borderColor: "#d1d5db",
    },
    superseded: {
      label: "Superseded",
      bgColor: "#fee2e2",
      textColor: "#991b1b",
      borderColor: "#fca5a5",
    },
  };

  // Normalize status to lowercase for lookup
  const normalizedStatus = (status || "").toLowerCase();
  const config = statusConfig[normalizedStatus] || statusConfig.draft;

  return (
    <div
      style={{
        display: "inline-block",
        padding: "4px 10px",
        borderRadius: "6px",
        backgroundColor: config.bgColor,
        color: config.textColor,
        border: `1px solid ${config.borderColor}`,
        fontSize: "0.7rem",
        fontWeight: "500",
        whiteSpace: "nowrap",
      }}
    >
      {config.label}
    </div>
  );
}
